import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {RestService} from "../rest.service.interface";
import {RestServiceImpl} from "../rest.service.impl";
import {LoggerService} from "../../../shared/logger.service";
import {AuthService} from "../../../shared/auth.service";
import {OaseInsertEditDialogComponent} from "../oase.insertEdit.component";
import {IconsSelectComponent} from "../bild/icons.select.component";
import {APIConfigService} from "../../../api.config.service";
import {HttpClient} from "@angular/common/http"; import {FormsModule} from "@angular/forms";
import {AngularMaterial2Module} from "../../../app.module.material";
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';

const PATH_FILE = 'app/protected/immerdrin/bearbeitung/insertEdit.mitDialogs.ts';

@Component({
    selector: 'oase-thema-insertEdit-mit-dialogs',
    templateUrl: './insertEdit.mitDialogs.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,	imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule  ]

})
export class InsertEditMitDialogs extends OaseInsertEditDialogComponent {

    dialogrunningajaxcall = false;

    constructor(
        public dialogRef: MatDialogRef<InsertEditMitDialogs>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dataService: RestService,
        public authService: AuthService,
		public apiConfigService: APIConfigService,
		public http: HttpClient,
        public dialog: MatDialog,
        // public dragulaService: DragulaService,
        public _logger: LoggerService) {

        super(dialogRef, data, dataService, _logger);

        this.specificInitHandling(this.aktuell);

    }

	public get REST_API(): string {
		return this.apiConfigService.REST_API_BASE()+this.BACKEND_PATH_PREFIX;
	}

    public specificInitHandling(aktuell: any) {
    }

    setFarbe(farbe) {
        if (farbe == null || this.aktuell.farbe == null) return;
        if (farbe.toUpperCase() !== this.aktuell.farbe.toUpperCase() && farbe !== 'none') {
            this.aktuell.farbe = farbe;
        }
    }

    public zeigeIconauswahlMaske() {
        this._logger.log(PATH_FILE + ' - zeigeIconauswahlMaske');

        const dialogRefIconSelect = this.dialog.open(IconsSelectComponent, {
            width: '600px',
            data: {
                aktuell: this.aktuell,
                OBJ_LNG_NAME: this.OBJ_LNG_NAME,
                BACKEND_PATH_PREFIX: this.BACKEND_PATH_PREFIX,
            }
        });

    }


}
